export enum OperatorSignType {
  ADDITION = 'Addition',
  SUBTRACTION = 'Subtraction',
  MULTIPLICATION = 'Multiplication',
  DIVISION = 'Division',
  POWER = 'Power',
  DIGIT = 'Digit',
  SQUARE_ROOT = 'SquareRoot',
  PARENTHESIS_EQUATION = 'ParenthesisEquation',
}

export interface EquationSign {
  type: OperatorSignType
  value?: string | number
  indexInEquation: number
  equation?: string
}
